import * as mdb from "mdb-ui-kit";
import Logo from './../img/logo.svg';

export default {
    mdb,
};

const logo = Logo;

